import React, { useContext, useState } from 'react'
import "./Shop.css"
import { NavLink } from 'react-router-dom';
import { AuthContext } from './Context';
function Beds() {
 const furnitureData=useContext(AuthContext)


    const [furniture,setFurniture]=useState("All")
    const [material,setMaterial]=useState("All")
    const [size,setSize]=useState("All Sizes")


    const bedArray=furnitureData.filter(furniture=>furniture.category.toLocaleLowerCase().includes("bed"))
    const bedArrayResults=bedArray.map((item)=>(
                   <div class="morara-card">
            <NavLink to={`/products/${item.id}`}>
            
            {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
          <img
            src={item.image} alt={item.name}
            class="morara-card-img"
          />
        
          <h3 class="morara-card-title">{item.name}</h3>
          <p class="morara-card-desc">
            {item.description}
          </p>
        
          <div class="morara-subimages">
        
            
        
            {item.subimages.map((img, index) => (
          <img key={index} src={img} alt={item.name} />
        ))}
        
        
           
          </div>
        <div className='morara-actions'>
          <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                              style: "currency",
                              currency: "KES",
                              minimumFractionDigits: 0,
                            }).format(item.price)}</p>
          <button class="morara-btn">View</button>
          </div>
        </NavLink>
        
        </div> 
        
        ))
    

    const kingsizebedArray=bedArray.filter(furniture=>furniture.size.toLocaleLowerCase().includes("king"))
    const kingsizebedArrayResults=kingsizebedArray.map((item)=>(
                   <div class="morara-card">
            <NavLink to={`/products/${item.id}`}>
            
            {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
          <img
            src={item.image} alt={item.name}
            class="morara-card-img"
          />
        
          <h3 class="morara-card-title">{item.name}</h3>
          <p class="morara-card-desc">
            {item.description}
          </p>
        
          <div class="morara-subimages">
        
            
        
            {item.subimages.map((img, index) => (
          <img key={index} src={img} alt={item.name} />
        ))}
        
        
           
          </div>
        <div className='morara-actions'>
          <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                              style: "currency",
                              currency: "KES",
                              minimumFractionDigits: 0,
                            }).format(item.price)}</p>
          <button class="morara-btn">View</button>
          </div>
        </NavLink>
        
        </div> 
        
        ))
    
    const queensizebedArray=bedArray.filter(furniture=>furniture.size.toLocaleLowerCase().includes("queen"))
 const queensizebedArrayResults=queensizebedArray.map((item)=>(
                   <div class="morara-card">
            <NavLink to={`/products/${item.id}`}>
            
            {item.onOffer?<span className='offer-season'>Offer</span>:<></>}
          <img
            src={item.image} alt={item.name}
            class="morara-card-img"
          />
        
          <h3 class="morara-card-title">{item.name}</h3>
          <p class="morara-card-desc">
            {item.description}
          </p>
        
          <div class="morara-subimages">
        
            
        
            {item.subimages.map((img, index) => (
          <img key={index} src={img} alt={item.name} />
        ))}
        
        
           
          </div>
        <div className='morara-actions'>
          <p class="morara-card-price">{new Intl.NumberFormat("en-KE", {
                              style: "currency",
                              currency: "KES",
                              minimumFractionDigits: 0,
                            }).format(item.price)}</p>
          <button class="morara-btn">View</button>
          </div>
        </NavLink>
        
        </div> 
        
        ))


  return (
    <>
     
  <header class="morara-header">
    <h1 class="morara-title">Morara Premium Beds</h1>
    <p class="morara-subtitle"> Elegant Beds • Home Comfort</p>
  </header>

  <section class="morara-filter-bar">
  <div class="morara-dropdown">
    <div class="morara-dropdown-selected" id="categorySelected" onClick={()=>{setFurniture("All")}}>{furniture}</div>
    <div class="morara-dropdown-options" id="categoryOptions">
      <div data-value="sofa" onClick={()=>{setFurniture("Beds")}} className={furniture==="Beds"?"furniture-active":""}>Beds</div>
    </div>
  </div>

  

  <div class="morara-dropdown">
    <div class="morara-dropdown-selected" id="seaterSelected">{size}</div>
    <div class="morara-dropdown-options" id="seaterOptions">
      <div data-value="all" onClick={()=>{setSize("All Sizes")}} className={material==="All Sizes"?"furniture-active":""}>All Sizes</div>
      <div data-value="3" onClick={()=>{setSize("Queen")}} className={material==="3seater"?"furniture-active":""}>Queen Size</div>
      <div data-value="5" onClick={()=>{setSize("King")}} className={material==="5seater"?"furniture-active":""}>King Size</div>
    </div>
  </div>
</section>

  <main id="moraraProducts" class="morara-products">
    
{size=="All Sizes" && bedArrayResults}
{size=="Queen" && queensizebedArrayResults}
{size=="King" && kingsizebedArrayResults}

</main>
 


    </>
  )
}

export default Beds
